import { render, staticRenderFns } from "./VModel.vue?vue&type=template&id=fb3ef47e&"
import script from "./VModel.vue?vue&type=script&lang=js&"
export * from "./VModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports